import React from 'react'

// not shown

const PartnersPage = () => {
  return (
    <div>
      partners
    </div>
  )
}

export default PartnersPage
